/**
 * Merge class names, filtering out falsy values.
 */
export function cn(...classes: Array<string | boolean | undefined | null>): string {
	return classes.filter(Boolean).join(" ");
}
